'use client';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { getWidthStyle } from '../../mixins/getWidthStyle.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { Box } from '../Box/Box.js';

const StyledContentWrapper = styled(Box).withConfig({
  componentId: "sc-u30ncd-0"
})(["", ";", ";position:relative;width:100%;margin:auto;", ";", ""], defaultStyles.boxSizing, defaultStyles.fontSmoothing, ({
  maxWidth,
  theme
}) => getWidthStyle(maxWidth || theme.maxWrapperWidth), ({
  spaceAfter
}) => spaceProp(spaceAfter));
const ContentWrapper = /*#__PURE__*/withTitan(({
  maxWidth,
  hasPadding,
  spaceAfter,
  className,
  children,
  id,
  px = {
    xs: 6,
    s: hasPadding ? 6 : 0
  },
  testId = 'contentWrapper'
}, ref) => jsx(StyledContentWrapper, {
  ref: ref,
  className: className,
  "data-test-id": testId,
  hasPadding: hasPadding,
  id: id,
  maxWidth: maxWidth,
  px: px,
  spaceAfter: spaceAfter,
  children: children
}), {
  name: 'ContentWrapper'
});

export { ContentWrapper };
//# sourceMappingURL=ContentWrapper.js.map
